const partners: { name: string; src?: string }[] = [
  { name: 'بانک شهر', src: '/assets/images/Svg/Licences/BankShahr.svg' },
  { name: 'هلدینگ آسان پرداخت' },
  { name: 'شرکت دیجی‌شهر' }
]

const AboutApoloan = () => {
  return (
    <section id="about" className="w-full border-t border-slate-200 bg-white py-12 tablet:py-16">
      <div className="mx-auto grid w-full max-w-[1280px] items-center gap-10 px-4 tablet:px-6 desktop:grid-cols-[1.4fr_0.8fr] desktop:px-8">
        <div>
          <h2 className="text-2xl font-black text-slate-900 tablet:text-[28px]">درباره آپولون</h2>
          <p className="mt-4 max-w-3xl text-sm leading-8 text-slate-600 tablet:text-base tablet:leading-9">
            آپولون، بازوی اعتباری بانک شهر با همکاری هلدینگ آسان پرداخت و شرکت
            دیجی‌شهر است که امکان دریافت اعتبار و خرید اعتباری از فروشگاه‌های
            آنلاین و حضوری طرف قرارداد را فراهم می‌کند.
          </p>
        </div>

        <div className="flex flex-wrap items-center justify-start gap-3 desktop:justify-end">
          {partners.map((partner) => (
            <div
              key={partner.name}
              className="flex h-16 min-w-[112px] items-center justify-center rounded-xl border border-slate-200 bg-slate-50 px-4"
            >
              {partner.src ? (
                <img
                  src={partner.src}
                  alt={partner.name}
                  className="h-10 w-auto max-w-[88px] object-contain opacity-80 grayscale"
                />
              ) : (
                <span className="text-center text-[11px] font-medium leading-5 text-slate-500">
                  {partner.name}
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default AboutApoloan
